// Vendor Libs
import {flatten, now, toLower} from 'lodash';

// Libs
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesConfig from '../../config/services-config';

export function authenticate({username, password, refreshToken}) {
    return (dispatch) =>
        new Promise((resolve) => {
            const dispatchFetched = (jsonResponse) => {
                const {access_token, refresh_token, expires_in, scope} = jsonResponse;

                Promise.resolve(
                    dispatch({
                        type: 'AUTHENTICATE_FETCH_FULFILLED',
                        payload: {
                            accessToken: access_token,
                            error: null,
                            expiresIn: expires_in,
                            fetched: true,
                            fetching: false,
                            scope: flatten([scope.toLowerCase().split(' ')]),
                            refreshToken: refresh_token,
                            ttl: now() + expires_in * 1000,
                            user: toLower(username),
                        },
                    })
                ).then(() =>
                    resolve({
                        accessToken: access_token,
                    })
                );
            };
            const dispatchError = (error) => {
                Promise.resolve(
                    dispatch({
                        type: 'AUTHENTICATE_FETCH_REJECTED',
                        error,
                    })
                ).then(() =>
                    resolve({
                        accessToken: null,
                        error,
                    })
                );
            };
            const actionParams = {
                servicesConfig: refreshToken ? servicesConfig.refreshToken : servicesConfig.authenticate,
                dispatchFetched,
                dispatchError,
            };

            if (username && password) {
                actionParams.authorization = {username, password};
            } else {
                actionParams.authorization = {refreshToken};
            }

            dispatch({
                type: 'AUTHENTICATE_FETCH',
            });

            return actionsServiceCaller(actionParams);
        });
}

export function logout(_goHome, error) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'AUTHENTICATE_LOGOUT',
                error,
            })
        );
}

export function clearError() {
    return (dispatch) => {
        dispatch({
            type: 'AUTHENTICATE_CLEAR_ERROR',
        });
    };
}
